import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOfferOnDiscountConfig } from "src/models/Offers/OfferOnDiscount.models";

interface OfferOnDiscountConfigState {
  offerOnDiscountConfigs: IOfferOnDiscountConfig[];
  offerOnDiscountConfigToEdit: IOfferOnDiscountConfig | null;
}

const initialState: OfferOnDiscountConfigState = {
  offerOnDiscountConfigs: [],
  offerOnDiscountConfigToEdit: null,
};

const offerOnDiscountConfigSlice = createSlice({
  name: "OfferOnDiscountConfig",
  initialState,
  reducers: {
    setOfferOnDiscountConfigList: (
      state,
      action: PayloadAction<IOfferOnDiscountConfig[]>
    ) => {
      state.offerOnDiscountConfigs = action.payload;
    },
    concatListOfferOnDiscountConfig: (
      state: OfferOnDiscountConfigState,
      action: PayloadAction<IOfferOnDiscountConfig[]>
    ) => {
      state.offerOnDiscountConfigs = [
        ...state.offerOnDiscountConfigs.concat(action.payload),
      ];
    },
    setOfferOnDiscountConfigToEdit: (
      state,
      action: PayloadAction<IOfferOnDiscountConfig | null>
    ) => {
      state.offerOnDiscountConfigToEdit = action.payload;
    },
    addOfferOnDiscountConfig: (
      state,
      action: PayloadAction<IOfferOnDiscountConfig>
    ) => {
      state.offerOnDiscountConfigs.push(action.payload);
    },
    updateOfferOnDiscountConfig: (
      state,
      action: PayloadAction<IOfferOnDiscountConfig>
    ) => {
      let itemIndex = state.offerOnDiscountConfigs.findIndex(
        item =>
          item.offerOnDiscountConfigId ===
          action.payload.offerOnDiscountConfigId
      );
      if (itemIndex !== -1)
        state.offerOnDiscountConfigs[itemIndex] = action.payload;
    },
    deleteOfferOnDiscountConfig: (state, action: PayloadAction<number>) => {
      const newArray = state.offerOnDiscountConfigs.filter(
        item => item.offerOnDiscountConfigId !== action.payload
      );
      state.offerOnDiscountConfigs = newArray;
    },
  },
});

export const {
  setOfferOnDiscountConfigList,
  concatListOfferOnDiscountConfig,
  setOfferOnDiscountConfigToEdit,
  addOfferOnDiscountConfig,
  updateOfferOnDiscountConfig,
  deleteOfferOnDiscountConfig,
} = offerOnDiscountConfigSlice.actions;

export default offerOnDiscountConfigSlice.reducer;
